import { render, staticRenderFns } from "./CurriculumVitaes.vue?vue&type=template&id=7659fcc5&scoped=true&"
import script from "./CurriculumVitaes.vue?vue&type=script&lang=js&"
export * from "./CurriculumVitaes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7659fcc5",
  null
  
)

export default component.exports